import { render, staticRenderFns } from "./GoogleTranslater.vue?vue&type=template&id=4a0a8122&scoped=true"
import script from "./GoogleTranslater.vue?vue&type=script&lang=js"
export * from "./GoogleTranslater.vue?vue&type=script&lang=js"
import style0 from "./GoogleTranslater.vue?vue&type=style&index=0&id=4a0a8122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0a8122",
  null
  
)

export default component.exports